import { useCountdown } from "@/hooks/useCountdown";

export default function CountdownBar() {
  const { formatted } = useCountdown();
  return (
    <div
      data-testid="countdown-bar"
      className="w-full bg-[#1A1A1A] text-[#F6F1E8] py-2.5 px-4 sm:px-6 md:px-12 lg:px-24"
    >
      <div className="flex items-center justify-between gap-3 sm:gap-4 text-[0.65rem] md:text-xs">
        <span className="eyebrow opacity-80 hidden md:inline">By Invitation · Essex · London · Kent · Suffolk</span>
        <div className="flex items-center gap-2 sm:gap-3 md:gap-5 mx-auto md:mx-0 min-w-0">
          <span className="eyebrow opacity-90 truncate">
            <span className="sm:hidden">Free £500 gift</span>
            <span className="hidden sm:inline">Free £500 consultation, framed print &amp; champagne</span>
          </span>
          <span className="hidden sm:inline h-3 w-px bg-[#F6F1E8]/30 shrink-0" />
          <span
            data-testid="countdown-timer"
            className="font-serif-display italic text-sm sm:text-base md:text-lg leading-none tracking-tight tabular-nums shrink-0"
          >
            {formatted}
          </span>
        </div>
        <a
          href="#apply"
          data-testid="countdown-cta"
          className="hidden md:inline eyebrow opacity-90 link-underline"
        >
          Apply Now →
        </a>
      </div>
    </div>
  );
}
